import React from 'react';
import Page from '../core/screens/Page';
import Grid from '../responsive/Grid';
import Button from '../ui/Button';
import * as Logos from '../ui/Logos';
import { ArrowRight, LinkArrow, MissionLogo } from '../ui/Vectors';

import '../css/screens/CityModelPage.scss';
import ContentBuilder from '../core/ContentBuilder';



export default class CityModelPage extends Page {

	build_project(data)
	{
		return (
			<section className='project'>
				<div className='header'>
					<div className="title">{data.title}</div>
					<div className="subtitle">{data.subtitle}</div>
				</div>
				<Grid cols={2} skip={1} className='padding' breakpoints={{small: {cols: 4, skip: 0}}}>
					<div className="text">{ContentBuilder.linkify(data.text1, LinkArrow)}</div>
				</Grid>
				<Grid cols={4} skip={0} className="text-center">
					<img className='image' src={data.image1.src} width={data.image1.width} height={data.image1.height} />
				</Grid>
				<Grid cols={2} skip={1} className='padding' breakpoints={{small: {cols: 4, skip: 0}}}>
					<div className="text">{ContentBuilder.linkify(data.text2, LinkArrow)}</div>
				</Grid>
			</section>
		)
	}

	build_naming(data)
	{
		return (
			<section className='naming'>
				<div className='header'>
					<div className="title">{data.title}</div>
					<div className="subtitle">{data.subtitle}</div>
				</div>
				<Grid cols={4} skip={0} className="padding">
					{ContentBuilder.build(data.content, LinkArrow)}
				</Grid>
			</section>
		)
	}

	build_explore(data)
	{
		return (
			<section className='explore'>
				<div className='header'>
					<div className="title">{data.title}</div>
					<div className="subtitle">{data.subtitle}</div>
				</div>
				<Grid cols={4} skip={0} className="padding">
					{ContentBuilder.build(data.content, LinkArrow)}
				</Grid>
				<Button grid={{default: {cols: 2, skip: 1}, small: {cols:4, skip: 0}}} link={data.button.link} border={true}>
					<span className="flex flex-baseline">
						<span className="label">{data.button.label}</span>
						<span className="description">{data.button.description}</span>
					</span>
					<span className="label-right flex-middle">
						<span className="actionLabel show-medium">{data.button.actionLabel}</span>
						<ArrowRight className='arrow'></ArrowRight>
					</span>
				</Button>
				<div className="padding text-right note">{data.note}</div>
			</section>
		)
	}

	render() {
		return this.wrap(
			<React.Fragment>
				{(this.props.content.project)?this.build_project(this.props.content.project):null}
				{(this.props.content.naming)?this.build_naming(this.props.content.naming):null}
				{(this.props.content.explore)?this.build_explore(this.props.content.explore):null}
			</React.Fragment>
		);
	}
}
